/**
 * Phase 65 — Proper WhatsApp brand icon.
 *
 * lucide-react ships MessageCircle which we were using previously — that's
 * a generic chat bubble, not the recognisable WhatsApp mark. This is the
 * official WhatsApp glyph inlined as an SVG for offline availability.
 *
 * Usage: <WhatsAppIcon className="w-4 h-4" />
 */
export default function WhatsAppIcon({ className = "w-4 h-4", ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill="currentColor"
            className={className}
            aria-label="WhatsApp"
            {...props}
        >
            <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.407-.545-.489-1.093-1.106-1.462-1.72-.061-.104-.083-.181-.033-.212.191-.117.502-.435.643-.678.108-.187.093-.464-.014-.678-.107-.213-.883-2.15-1.202-2.955-.319-.805-.591-.667-.805-.667-.213-.005-.34-.005-.554-.005-.213 0-.554.083-.803.396-.249.313-.883.965-.883 2.353 0 1.388.883 2.735 1.024 2.923.14.187 1.767 3.055 4.399 4.156 2.632 1.1 2.632.734 3.106.689.474-.046 1.501-.614 1.712-1.206.211-.591.211-1.098.148-1.206-.063-.107-.222-.171-.469-.293z"/>
            <path d="M26.576 5.363c-2.926-2.925-6.813-4.535-10.965-4.535-8.573 0-15.55 6.977-15.55 15.55 0 2.735.716 5.408 2.079 7.769L0 32l7.943-2.083c2.271 1.238 4.833 1.902 7.679 1.902h.005c8.574 0 15.55-6.977 15.55-15.55.001-4.148-1.61-8.038-4.601-10.906zm-10.965 23.855h-.006c-2.534 0-4.98-.678-7.115-1.976l-.51-.301-5.29 1.387 1.412-5.157-.334-.531c-1.428-2.271-2.176-4.891-2.176-7.58 0-7.856 6.396-14.256 14.257-14.256 3.803 0 7.386 1.487 10.077 4.183 2.69 2.696 4.171 6.28 4.17 10.077-.008 7.861-6.402 14.154-14.485 14.154z"/>
        </svg>
    );
}
